<template>
    <div class="list-product-card">
        <div class="list-product-card-inner">
            <div class="product-card-left">
                <a :href="productUrl" class="product-image">
                    <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">

                    <ul class="list-inline product-badge">
                        <li class="badge badge-danger" v-if="product.is_out_of_stock">
                            {{ $trans('storefront::product_card.out_of_stock') }}
                        </li>

                        <li class="badge badge-primary" v-else-if="product.is_new">
                            {{ $trans('storefront::product_card.new') }}
                        </li>

                        <li class="badge badge-success" v-if="product.has_percentage_special_price">
                            -{{ product.special_price_percent }}%
                        </li>
                    </ul>
                </a>
            </div>

            <div class="product-card-right">
                <a :href="productUrl" class="product-name">
                    <h6>{{ product.name }}</h6>
                    <h6><strong>N.{{ product.code }}</strong></h6>
                </a>

                <div class="clearfix"></div>

                <ProductRating :ratingPercent="product.rating_percent" :reviewCount="product.reviews.length"/>

                <div class="product-price" v-html="product.formatted_price"></div>

                <div class="btn-add-to-cart"  v-if="hasNoOption || product.is_out_of_stock">
                    <div class="buybox--button-container block-group input-group-quantity">


                        <div class="aian-select-icon"
                            :class="{'d-none': !productInCart }"
                        >
                            <div class="select-field">
                                <select
                                @change="addToCart2($event)"
                                name="qty"
                                class="quantity_of_product"
                            >
                            <option v-for="(count,index) in product.qty || 101"
                            :key="index"
                            :value="index"
                            :selected="productInCart && index == productInCart.qty"
                            >
                            {{ index }}
                            </option>


                                </select>
                            </div>
                        </div>

                    </div>
                    <button
                        class="btn btn-primary btn-block"
                        @click="addToCart"
                        :disabled="product.is_out_of_stock"
                        :class="{'is--open': productInCart, 'btn-loading': addingToCart}"
                      >
                        <i class="las la-cart-arrow-down" style="font-size:18px"></i>
                    </button>
                    <br>
                </div>

                <a
                    v-else
                    :href="productUrl"
                    class="btn btn-primary btn-add-to-cart"
                >
                    <i class="las la-eye"></i>
                    {{ $trans('storefront::product_card.view_options') }}
                </a>
            <div class="clearfix"></div>
                <div class="product-card-actions">
                    <button
                        class="btn btn-wishlist"
                        :class="{ 'added': inWishlist }"
                        @click="syncWishlist"
                    >
                        <i class="la-heart" :class="inWishlist ? 'las' : 'lar'"></i>
                        {{ $trans('storefront::product_card.wishlist') }}
                    </button>

                    <button
                        v-if="showComparisonButton()"
                        class="btn btn-compare"
                        :class="{ 'added': inCompareList }"
                        @click="syncCompareList"
                    >
                        <i class="las la-balance-scale-left"></i>
                        {{ $trans('storefront::product_card.compare') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductRating from './../../ProductRating.vue';
    import ProductCardMixin from '../../../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
